// src/components/tabs/CastTab.jsx
import React from 'react';

function CastTab({ movie }) {
  if (!movie) return <div>No movie selected</div>;
  
  return (
    <div className="cast-tab">
      <h2>Cast</h2>
      <div className="cast-grid">
        {movie.cast?.length ? (
          movie.cast.map((person, index) => (
            <div key={`cast-${index}`} className="cast-member">
              <div className="cast-photo">
                <img 
                  src={person.profile_path 
                    ? `https://image.tmdb.org/t/p/w185${person.profile_path}` 
                    : '/placeholder-person.jpg'} 
                  alt={person.name} 
                />
              </div>
              <h3>{person.name}</h3>
              <p className="character">{person.character}</p>
            </div>
          ))
        ) : (
          <p>No cast information available</p>
        )}
      </div>
      
      <h2>Crew</h2>
      <div className="crew-grid">
        {movie.crew?.length ? (
          movie.crew.map((person, index) => (
            <div key={`crew-${index}`} className="crew-member">
              <div className="crew-photo">
                <img 
                  src={person.profile_path 
                    ? `https://image.tmdb.org/t/p/w185${person.profile_path}` 
                    : '/placeholder-person.jpg'} 
                  alt={person.name}
                />
              </div>
              <h3>{person.name}</h3>
              <p className="job">{person.job}</p>
            </div>
          ))
        ) : (
          <p>No crew information available</p>
        )}
      </div>
    </div>
  );
}

export default CastTab;